export function scrollToElement(element, offsetChange, duration = 1000) {
    const offsetTop = $(element).offset().top;
    const position = offsetChange ? offsetTop - offsetChange : offsetTop;
    $('html, body').animate({
        scrollTop: position
    }, duration);
}

export function scrollToPosition (element, offset, duration) {
    const elementPosition = $(element).offset().top;
    const windowHeight =  $(window).height();
    const elementHeight = $(element).height();
    const scrolledPosition = elementPosition - windowHeight + elementHeight + offset;
    $('html, body').animate({
        scrollTop: scrolledPosition
    }, duration);
}

export function scrollToRelativeElement(parentElement, element, duration = 1000) {
    const positionTop = $(element).position().top - $(parentElement).position().top + $(parentElement).scrollTop();
    $(parentElement).animate({
        scrollTop: positionTop
    }, duration);
}
